/**
 * @generated SignedSource<<b5a78eef9acd278919c9d4df606f0dc5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type ProviderRegionStock = "AU" | "BR" | "CA" | "CN" | "EU" | "EU_ES" | "EU_LV" | "JP" | "MX" | "UK" | "US" | "_UNDEFINED";
export type editConfigurationQuery$variables = {
  id: string;
  provider: ProductProvider;
};
export type editConfigurationQuery$data = {
  readonly retailProduct: {
    readonly profitPercentage: number;
    readonly variants: ReadonlyArray<{
      readonly availabilityStatus: ReadonlyArray<{
        readonly region: ProviderRegionStock;
        readonly status: string;
      }>;
      readonly canRotate: boolean;
      readonly colorCode: string | null;
      readonly colorName: string | null;
      readonly imageUrl: string;
      readonly inStock: boolean;
      readonly isColored: boolean;
      readonly name: string;
      readonly price: string;
      readonly productId: number;
      readonly size: string;
      readonly variantID: number;
    }>;
  };
};
export type editConfigurationQuery = {
  response: editConfigurationQuery$data;
  variables: editConfigurationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "provider"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "provider",
        "variableName": "provider"
      }
    ],
    "concreteType": "ProductProviderRetailProduct",
    "kind": "LinkedField",
    "name": "retailProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profitPercentage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductProviderProductVariant",
        "kind": "LinkedField",
        "name": "variants",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "variantID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canRotate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isColored",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inStock",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "productId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "size",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AvailabilityStatus",
            "kind": "LinkedField",
            "name": "availabilityStatus",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "region",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "editConfigurationQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "editConfigurationQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "64fbdaa260fa045204ed1b1e42d78006",
    "id": null,
    "metadata": {},
    "name": "editConfigurationQuery",
    "operationKind": "query",
    "text": "query editConfigurationQuery(\n  $id: String!\n  $provider: ProductProvider!\n) {\n  retailProduct(id: $id, provider: $provider) {\n    profitPercentage\n    variants {\n      variantID\n      name\n      canRotate\n      colorCode\n      colorName\n      isColored\n      imageUrl\n      inStock\n      price\n      productId\n      size\n      availabilityStatus {\n        region\n        status\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "03aa9344207515964f826872786300f9";

export default node;
